import { useRef, useState } from 'react'
import {
  Box,
  Divider,
  IconButton,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { useTranslation } from 'react-i18next'

// import { CircleDownIcon, CircleUpIcon } from 'src/assets/icons'
import { GridItemCollapse } from './item-collapse.component'
import { GridPopper } from 'src/components/grid-card/grid-popper.component'
import { ETranslationNs, IDraftScanRespDto, IGridPopperListItem } from 'src/types'

import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { ChevronUpIcon } from 'src/assets/icons/v2/ChevronUpIcon'
import { ChevronDownIcon } from 'src/assets/icons/v2/ChevronDownIcon'

interface IChangesGridItemProps {
  handleClick?: () => void
  item: IDraftScanRespDto
  handleDelete: (id: string) => () => void
}

export const GridItem = ({ item, handleClick, handleDelete }: IChangesGridItemProps) => {
  const [t] = useTranslation()
  const [toggle, setToggle] = useState(false)
  const [open, setOpen] = useState(false)
  const classes = useStyles()
  const anchorRef = useRef<HTMLButtonElement>(null)
  const theme = useTheme()

  const handleCollapse = () => {
    setToggle((toggle) => !toggle)
  }

  const handleMoreClick = () => {
    setOpen((toggle) => !toggle)
  }

  const moreItems: IGridPopperListItem[] = [
    {
      title: t('delete-button-text.v', { ns: ETranslationNs.Common }),
      onClick: handleDelete(item.id),
    },
  ]

  return (
    <>
      <ListItemButton onClick={handleCollapse} disableGutters sx={{ p: '10px 6px' }}>
        <div>
          <ListItemIcon>
            {toggle ? (
              <ChevronUpIcon size={28} color={theme.palette.custom.darkBlue2} />
            ) : (
              <ChevronDownIcon size={28} color={theme.palette.custom.darkBlue2} />
            )}
          </ListItemIcon>
        </div>
        {/* <ListItemText className={classes.collapseItem} disableTypography>
          <div>
            <Typography className={`${classes.itemText} ${classes.itemPropertyText}`}>
              {item.batch_id || '-'}
            </Typography>
            <Typography className={classes.itemText}>
              <HelperWrapper t="batch-id-table-column" ns={ETranslationNs.Scans} />
            </Typography>
          </div>
          <IconButton ref={anchorRef} onClick={handleMoreClick} className={classes.moreButton}>
            <MoreVertIcon />
          </IconButton>
        </ListItemText> */}
        <ListItemText className={classes.collapseItem} disableTypography>
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <Typography className={`${classes.itemText} ${classes.itemPropertyText}`}>
                <HelperWrapper t="batch-id-table-column" ns={ETranslationNs.Scans} /> :
              </Typography>
              <Typography className={classes.itemText}>{item.batch_id || '-'}</Typography>
            </Box>
            <IconButton
              ref={anchorRef}
              onClick={(e) => {
                e.stopPropagation()
                handleMoreClick()
              }}
              className={classes.moreButton}
            >
              <MoreVertIcon />
            </IconButton>
          </Box>
        </ListItemText>
      </ListItemButton>
      <GridItemCollapse handleClick={handleClick} item={item} open={toggle} />
      <Divider />
      <GridPopper
        items={moreItems}
        handleClose={handleMoreClick}
        open={open}
        anchorRef={anchorRef}
      />
    </>
  )
}
